import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import withStyles from 'beam/dist/styles'
import Typography from 'beam/dist/Typography'

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    height: '100%',
  },
  details: {
    whiteSpace: 'pre-wrap',
  },
})

class ErrorBoundary extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  }

  state = { error: false }

  static getDerivedStateFromError() {
    return { error: true }
  }

  componentDidCatch(error, info) {
    this.setState({ error })
    // You can also log the error to an error reporting service
    // TODO: add logging service
    window.logErrorToMyService && window.logErrorToMyService(error, info)
  }

  render() {
    const { error } = this.state
    const { t, classes, children } = this.props
    return error ? (
      <div className={classes.root}>
        <Typography color="primary" align="center">
          {t('error')}
        </Typography>
        <Typography color="primary" align="center">
          {t('somethingWentWrong')}
        </Typography>
        {error?.instructions && (
          <Typography color="primary" align="center">
            {t(error.instructions)}
          </Typography>
        )}
        <Typography color="primary" align="center">
          {t('contactSysAdmin')}
        </Typography>

        <details className={classes.details}>
          <Typography>{error.toString()}</Typography>
        </details>
      </div>
    ) : (
      children
    )
  }
}

export default withTranslation()(withStyles(styles)(ErrorBoundary))
